module.exports = __webpack_public_path__ + "static/media/about-slide-img-2.fcd5b766.svg";